import React, { useEffect } from "react";
import CustomCardBase from "./CustomCardBase";
import URI from "urijs";
import general from "../../../../../../general";
import { NavLink } from "../../../../../../lib/Navigation";
import useActiveState from "../../../../../../lib/useActiveState";

export default function GreatGamesMessage({ msg }) {

  const { attach } = msg;
  const [agent] = useActiveState("agent");

  useEffect(() => {
    console.log("GreatGamesMessage", attach);
  }, [attach]);

  return (
    <NavLink
      to={(() => {
        let url = URI(attach?.url || "")
          .addQuery("username", localStorage.getItem("username"))
          .addQuery("token", localStorage.getItem("token"))
          .addQuery("location_url", window.location.origin)
          .addQuery("origin", "react")
          .addQuery("agent", agent)
          .addQuery("from", "react")
          .toString();
        return url;
      })()}
      iframe={{ title: attach?.title }}
      user={true}
    >
      <CustomCardBase
          tagColor="#6167E0"
          tagText="活动"
          title={attach?.title}
          gameInfo={attach?.game_info}
          desc={`活动时间: ${attach?.time}`}
          descClass="imc-line2"
        />
      {/* <div className="imc-card">
        <div className="imc-card-head">
          <span className="imc-card-tag" style={{ backgroundColor: "#6167E0" }}>
            {"活动"}
          </span>
          <span className="imc-card-tag-title" style={{ color: "#6167E0" }}>
            {attach?.title}
          </span>
        </div>
        <div className="imc-card-body">
          <div className="imc-card-content">
            <div className="imc-card-gamename">
            {attach?.game_info?.game_name}
            {attach?.game_info?.nameRemark ? "-" + attach?.game_info.nameRemark : ""}
          </div>
            <div style={{ fontSize: 12, color: "#999", paddingTop: 3 }}>
              活动时间: {attach?.time}
            </div>
          </div>
          <img
            height={63}
            src={attach?.game_info.game_image.thumb}
            alt=""
            className="imc-card-thumb"
          />
        </div>
      </div> */}
    </NavLink>
  );
}
